import { createSlice } from '@reduxjs/toolkit'
import { fetchCartDetails, fetchCurrentUserCartDetails } from '../actions/cartActions'

const CartReducers = createSlice({
    name: 'CartReducers',
    initialState: {
        loader: false,
        errors: null,
        cart: null,
        carts: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            /**
             * ALL CART DETAILS
             */
            .addCase(fetchCartDetails.pending, (state) => {
                state.loader = true;
                state.errors = null; 
            })
            .addCase(fetchCartDetails.fulfilled, (state, action) => {
                state.loader = false;
                state.carts = action.payload.data;
            })
            .addCase(fetchCartDetails.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; 
            })

            /**
             * FETCH CURRENT USER CART DETAILS
             */
            .addCase(fetchCurrentUserCartDetails.pending, (state) => {
                state.loader = true;
                state.errors = null; 
            })
            .addCase(fetchCurrentUserCartDetails.fulfilled, (state, action) => {
                state.loader = false;
                state.cart = action.payload.data;
            })
            .addCase(fetchCurrentUserCartDetails.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; 
            })
    }
})

export default CartReducers.reducer